import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'PIs',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'pis',
                },
              },
              subqueries: {
                pis: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'rooms',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!space',
                      },
                      using: 'personSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                    },
                    personSpace: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!personnel',
                        inherit: '-',
                      },
                      target: 'ent:!person_space:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '!=': [
                      {
                        '@': 'space',
                      },
                      null,
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              period: {
                $range: {
                  end: {
                    $date: '12/31/2024',
                  },
                  start: {
                    $date: '1/1/2024',
                  },
                },
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpenses',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'totalIdcr',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpensesInMtdc',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  3,
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'glExpenses',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      idcrDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    null,
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'totalIdcr',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdc',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'space',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'awardFundings',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '@': 'glExpensesInMtdcInLastThreeYears',
                                              },
                                            },
                                            3,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'space',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                    null,
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'totalIdcr',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          piHide: true,
                                          piRecordId: {
                                            '@.': '!id',
                                          },
                                          orgEntityId: 'null',
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                space: {
                  ref: {
                    attr: 'attr:ent#!person_space#!entry:!space',
                    inherit: '=',
                  },
                  using: 'personSpace',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '{}': {
                      asf: {
                        '*': [
                          {
                            '@>': 'sqft',
                          },
                          {
                            '@>': 'utilization',
                          },
                        ],
                      },
                      sqft: {
                        '@.': '!sqft',
                      },
                      utilization: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '+': {
                                    '@': 'weights',
                                  },
                                },
                                0,
                              ],
                            },
                            0,
                          ],
                          {
                            '/': [
                              {
                                '+': {
                                  '@': 'allowableWeights',
                                },
                              },
                              {
                                '+': {
                                  '@': 'weights',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                    },
                    allowableWeights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '!=': [
                          {
                            '@': 'funcIdCat',
                          },
                          null,
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      subqueries: {
                        funcIdCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'projects',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': '!id',
                          },
                          {
                            '@>': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'projects',
                                  },
                                },
                              },
                              'ent:!projects:!proj',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                },
                totalIdcr: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projects',
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!acct',
                          {
                            ref: {
                              entity: '!acct',
                            },
                          },
                        ],
                      },
                      '?7631013',
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projects',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'projectsResearchType',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
                personSpace: {
                  ref: {
                    attr: 'attr:ent#!person_space#!entry:!personnel',
                    inherit: '-',
                  },
                  target: 'ent:!person_space:!entry',
                },
                awardFundings: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  using: 'projects',
                  filter: {
                    or: [
                      {
                        '``': {
                          if: [
                            [
                              {
                                '=': [
                                  {
                                    '@$': 'researchType',
                                  },
                                  null,
                                ],
                              },
                              true,
                            ],
                            false,
                          ],
                        },
                      },
                      {
                        in: [
                          {
                            '@.': '!research_type_wfuhs',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!budget',
                  },
                },
                glExpensesInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projects',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  target: 'ent:!proj_pis:!entry',
                },
                glExpensesInMtdcInLastThreeYears: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projects',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2022',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'spaceRecordId',
                        },
                        null,
                      ],
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            id: 'awardFunding',
                            direct: {
                              '{}': {
                                name: 'Award Funding',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdc',
                            direct: {
                              '{}': {
                                name: 'TDC Expense',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdcDensity',
                            direct: {
                              '{}': {
                                name: 'TDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdc',
                            direct: {
                              '{}': {
                                name: 'MTDC Expense',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvg',
                            direct: {
                              '{}': {
                                name: 'MTDC Average',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvgDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Average Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'idcr',
                            direct: {
                              '{}': {
                                name: 'IDC-R',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'idcrDensity',
                            direct: {
                              '{}': {
                                name: 'IDC-R Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'effectiveRecovery',
                            direct: {
                              '{}': {
                                name: 'Effective Recovery',
                                type: 'PERCENT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'asf',
                            direct: {
                              '{}': {
                                name: 'ASF',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'projects',
                            direct: {
                              '{}': {
                                name: 'Projects',
                                type: 'INT',
                              },
                            },
                          },
                        },
                      ],
                    },
                  ],
                  {
                    '[]': [
                      {
                        '{}': {
                          id: 'asf',
                          direct: {
                            '{}': {
                              name: 'ASF',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'totalSqft',
                          direct: {
                            '{}': {
                              name: 'Total Area',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'utilization',
                          direct: {
                            '{}': {
                              name: 'Utilization',
                              type: 'PERCENT',
                            },
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcr',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      idcrDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'utilization',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'awardFunding',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAvgDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'space',
                          },
                          null,
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2024',
                      },
                    },
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '{}': {
                      asf: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'space',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      tdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpenses',
                            },
                          },
                          0,
                        ],
                      },
                      idcr: {
                        '+': {
                          '@': 'totalIdcr',
                        },
                      },
                      mtdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdc',
                            },
                          },
                          0,
                        ],
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                      totalSqft: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'space',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      tdcDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'glExpenses',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      idcrDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                null,
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'totalIdcr',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      utilization: {
                        '??': [
                          {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'space',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          0,
                        ],
                      },
                      awardFunding: {
                        '??': [
                          {
                            '+': {
                              '@': 'awardFundings',
                            },
                          },
                          0,
                        ],
                      },
                      mtdcAvgDensity: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdcInLastThreeYears',
                                          },
                                        },
                                        3,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'space',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'asf',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      effectiveRecovery: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '@': 'glExpensesInMtdc',
                                  },
                                },
                                null,
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'totalIdcr',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '@': 'glExpensesInMtdc',
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcInLastThreeYears: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdcInLastThreeYears',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    space: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!space',
                        inherit: '=',
                      },
                      using: 'personSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@>': 'sqft',
                              },
                              {
                                '@>': 'utilization',
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                          utilization: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'weights',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'allowableWeights',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'weights',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                        },
                        allowableWeights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@': 'funcIdCat',
                              },
                              null,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'projects',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!id',
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'projects',
                                      },
                                    },
                                  },
                                  'ent:!projects:!proj',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                    },
                    totalIdcr: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!acct',
                              {
                                ref: {
                                  entity: '!acct',
                                },
                              },
                            ],
                          },
                          '?7631013',
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    personSpace: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!personnel',
                        inherit: '-',
                      },
                      target: 'ent:!person_space:!entry',
                    },
                    awardFundings: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!award',
                      },
                      using: 'projects',
                      filter: {
                        or: [
                          {
                            '``': {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '@$': 'researchType',
                                      },
                                      null,
                                    ],
                                  },
                                  true,
                                ],
                                false,
                              ],
                            },
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': '!budget',
                      },
                    },
                    glExpensesInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    glExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    researchType: ['BASIC RESEARCH'],
  },
}
